var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        {
          staticClass: "section py-lg-5 py-0 my-lg-5 my-0 reverse-sm",
          attrs: { id: "specialties" }
        },
        [
          _c(
            "base-modal",
            {
              attrs: { title: _vm.$t("our-specialties") },
              model: {
                value: _vm.showAllSpecialties,
                callback: function($$v) {
                  _vm.showAllSpecialties = $$v
                },
                expression: "showAllSpecialties"
              }
            },
            [
              _c(
                "b-row",
                _vm._l(_vm.items, function(item) {
                  return _c(
                    "b-col",
                    {
                      key: item,
                      staticClass: "text-left",
                      attrs: {
                        cols: "12",
                        sm: "3",
                        "offset-sm": _vm.calculateOffsetItemInModal(item)
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "mr-3",
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/tick-rounded.svg"
                        }
                      }),
                      _vm._v("\r\n          " + _vm._s(item) + "\r\n        ")
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "my-auto content", attrs: { md: "12", lg: "6" } },
            [
              _c("h3", [_vm._v(_vm._s(_vm.$t("our-specialties")))]),
              _vm._v(" "),
              _c("div", { staticClass: "subtitle" }, [
                _c(
                  "div",
                  { staticClass: "subtitle-list mt-5" },
                  _vm._l(_vm.items.slice(0, 8), function(item) {
                    return _c(
                      "b-row",
                      { key: item, staticClass: "mb-3" },
                      [
                        _c("b-col", { attrs: { cols: "12" } }, [
                          _c("span", [
                            _c("img", {
                              staticClass: "mr-3",
                              attrs: {
                                src:
                                  "/static-appopensalud/img/icons/morillas-svg-icons/primary/tick-rounded.svg"
                              }
                            }),
                            _vm._v(_vm._s(item) + "\r\n              ")
                          ])
                        ])
                      ],
                      1
                    )
                  }),
                  1
                )
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "base-button",
                {
                  attrs: { outline: "", shadow: "" },
                  on: {
                    click: function($event) {
                      _vm.showAllSpecialties = true
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("see-all-specialties")))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "py-sm-0 py-lg-5 pl-lg-5",
              attrs: { md: "12", lg: "6" }
            },
            [_c("div", { staticClass: "col-bg ml-lg-auto" })]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-884c3784", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-884c3784","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/openlegal/OpenlegalSpecialties.vue
// module id = 3724
// module chunks = 12